import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
// path:的变量要小写
const routes = [
  {
    path: "/homePage",
    name: "HomePage",
    component: () => import("../views/HomePage.vue"),
    meta: {
      id: 0,
      text: "首页",
    },
    child: [],
  },
  {
    path: "/onlinecourse",
    name: "OnlineCourse",
    component: () => import("../views/OnlineCourse.vue"),
    meta: {
      id: 1,
      text: "在线课程",
    },
    child: [],
  },
  {
    path: "/training",
    name: "Training",
    component: () => import("../views/Traning.vue"),
    meta: {
      id: 2,
      text: "证书培训",
    },
    child: [],
  },
  {
    path: "/guidance",
    name: "Guidance",
    component: () => import("../views/Guidance.vue"),
    meta: {
      id: 3,
      text: "竞赛指导",
    },
    child: [],
  },
  {
    path: "/imitate",
    name: "Imitate",
    component: () => import("../views/Imitate.vue"),
    meta: {
      id: 4,
      text: "实训模拟",
    },
    child: [],
  },
  {
    path: "",
    name: "",
    component: () => "",
    meta: {
      id: 5,
      text: "就业创业",
    },
    child: [
      // {
      //   path: "/findjob",
      //   name: "FindJob",
      //   component: () => import('../views/FindJob.vue'),
      //   meta: {
      //     id: 5,
      //     text: "公司招聘",
      //   },
      // },
      // {
      //   path: "/goodstu",
      //   name: "GoodStu",
      //   component: () => import('../views/GoodStudent.vue'),
      //   meta: {
      //     id: 5,
      //     text: "优秀学员",
      //   },
      // },
    ],
  },
  {
    path: "/news",
    name: "News",
    component: () => import("../views/News.vue"),
    meta: {
      id: 6,
      text: "新闻资讯",
    },
    child: [],
  },
  {
    path: "/contactUs",
    name: "ContactUs",
    component: () => import("../views/ContactUs.vue"),
    meta: {
      id: 7,
      text: "关于我们",
    },

    child: [],
  },
  // type:"detail" 详情页面

  {
    path: "/newsinfo",
    name: "NewsInfo",
    component: () => import("../views/Newsinfor.vue"),
    meta: {
      type: "detail",
      id: 6,
      text: "新闻资讯",
    },
    child: [],
  },
  {
    path: "/guidanceinfo",
    name: "GuidanceInfo",
    component: () => import("../views/Guidanceinfo.vue"),
    meta: {
      type: "detail",
      id: 3,
      text: "竞赛指导",
    },
  },
  {
    path: "/trainingInfor",
    name: "TrainingInfor",
    component: () => import("../views/Traininginfor.vue"),
    meta: {
      type: "detail",
      id: 2,
      text: "证书培训",
    },
    child: [],
  },

  // type:"child"，二级导航
  {
    path: "/findjob",
    name: "FindJob",
    component: () => import("../views/FindJob.vue"),
    meta: {
      type: "child",
      id: 5,
      text: "公司招聘",
    },
    child: [],
  },
  {
    path: "/stujob",
    name: "Stujob",
    component: () => import("../views/StudentJob.vue"),
    meta: {
      type: "child",
      id: 5,
      text: "学生就业",
    },
    child: [],
  },
  {
    path: "/userinfo",
    name: "Userinfo",
    component: () => import("../views/Userinfo.vue"),
    meta: {
      type:"detail",
      id:undefined,
      text: "账号资料",
    },
    child: [],
  },
];

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

const router = new VueRouter({
  mode: "hash",
  // base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  //路由拦截
  document.title = `${to.meta.text}`;
  next();
});
export default router;
